import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.4997 0.125C4.77051 0.125 0.0830078 4.80208 0.0830078 10.5625C0.0830078 15.7708 3.89551 20.0937 8.87467 20.875V13.5833H6.22884V10.5625H8.87467V8.26042C8.87467 5.64583 10.4268 4.20833 12.8122 4.20833C13.9476 4.20833 15.1351 4.40625 15.1351 4.40625V6.97917H13.8226C12.5309 6.97917 12.1247 7.78125 12.1247 8.60417V10.5625H15.0205L14.5518 13.5833H12.1247V20.875C14.5793 20.4873 16.8145 19.2349 18.4267 17.3438C20.0389 15.4527 20.9219 13.0475 20.9163 10.5625C20.9163 4.80208 16.2288 0.125 10.4997 0.125Z" }, null, -1)
  ])))
}
export default { render: render }